
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8.5","cy":"8.5","r":"7","fill":"#94CC3F"}}),_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","d":"M11.65 6.75 7.1 11.3 5 9.2"}})])
          )
        }
      }
    